import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
    { to: "/scooters", label: "Rent a Scooter" },
    { to: "/delivery-area", label: "Delivery Area" },
    { to: "/rental-policies", label: "Policies" },
    { to: "/faq", label: "FAQ" },
    { to: "/contact", label: "Contact" },
];

export default function Header() {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-40 border-b border-slate-200/70 bg-white/90 backdrop-blur-md"
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
                <Link
                    to="/"
                    data-testid="header-logo-link"
                    className="flex items-center gap-3"
                    onClick={() => setOpen(false)}
                >
                    <img
                        src="/brand/logo.png"
                        alt="Central Florida Mobility Rentals"
                        className="h-12 w-12 rounded-full object-contain sm:h-14 sm:w-14"
                    />
                    <div className="hidden leading-tight sm:block">
                        <div className="font-display text-base font-extrabold tracking-tight text-[color:var(--brand-navy)] sm:text-lg">
                            Central Florida Mobility Rentals
                        </div>
                        <div className="text-xs font-medium text-[color:var(--brand-green)]">
                            Freedom Delivered.
                        </div>
                    </div>
                </Link>

                <nav className="hidden items-center gap-8 lg:flex">
                    {NAV.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            data-testid={`nav-${item.to.replace("/", "") || "home"}`}
                            className={({ isActive }) =>
                                `nav-link text-sm font-medium ${
                                    isActive
                                        ? "active text-[color:var(--brand-navy)]"
                                        : "text-slate-600 hover:text-[color:var(--brand-navy)]"
                                }`
                            }
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden items-center gap-3 lg:flex">
                    <button
                        type="button"
                        data-testid="header-book-now-button"
                        onClick={() => navigate("/scooters/pride-victory-10")}
                        className="pill-btn hero-cta text-white"
                    >
                        Book Now
                    </button>
                </div>

                <button
                    type="button"
                    data-testid="header-mobile-toggle"
                    className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 text-[color:var(--brand-navy)]"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Toggle menu"
                >
                    {open ? (
                        <X className="h-5 w-5" />
                    ) : (
                        <Menu className="h-5 w-5" />
                    )}
                </button>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="border-t border-slate-200 bg-white lg:hidden"
                >
                    <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3">
                        {NAV.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-${item.to.replace("/", "") || "home"}`}
                                className={({ isActive }) =>
                                    `rounded-lg px-3 py-3 text-sm font-medium ${
                                        isActive
                                            ? "bg-slate-100 text-[color:var(--brand-navy)]"
                                            : "text-slate-700 hover:bg-slate-50"
                                    }`
                                }
                            >
                                {item.label}
                            </NavLink>
                        ))}
                        <button
                            type="button"
                            data-testid="mobile-book-now-button"
                            onClick={() => {
                                setOpen(false);
                                navigate("/scooters/pride-victory-10");
                            }}
                            className="hero-cta pill-btn mt-2 text-white"
                        >
                            Book Now
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
}
